const teas = [
  {
    id: "whitetea",
    name: "White Tea",
    price: 10,
    description: "White tea with the taste of vanilla and coconut.",
  },
  {
    id: "blacktea",
    name: "Black Tea",
    price: 20,
    description: "A dark and rich superb Assam, India black tea.",
  },
  {
    id: `greentea`,
    name: "Green Tea",
    price: 15,
    description: "Rare, green tea scented with jasmine flowers.",
  },
  {
    id: "oolongtea",
    name: "Oolong Tea",
    price: 30,
    description: "Traditional chinese tea,produced through a long process",
  },
  {
    id: "puertea",
    name: "Puer Tea",
    price: 18,
    description: "Sweet, bitter, floral and slightly woody taste.",
  },
  {
    id: `darktea`,
    name: "Dark Tea",
    price: 25,
    description: "Deep aroma, a bit nutty and definitely bold.",
  },
  {
    id: "earlgreytea",
    name: "Earl Grey",
    price: 30,
    description: "Flavored with bergamot oil, lending it a perfumey musk.",
  },
  {
    id: "matchatea",
    name: "Matcha",
    price: 22,
    description: "This green tea comes as a stone-ground powder.",
  },
  {
    id: `rooibostea`,
    name: "Rooibos Tea",
    price: 25,
    description:
      "Smooth and gentle with a natural sweetness and slightly nutty taste.",
  },
  {
    id: "masalatea",
    name: "Masala Chai",
    price: 20,
    description: "Ginger and cardamon mixed with milk and sugar. ",
  },
  {
    id: "senchatea",
    name: "Sencha",
    price: 40,
    description: "The most popular Japanese tea, served as leaves.",
  },
  {
    id: `herbaltea`,
    name: "Herbal Tea",
    price: 25,
    description:
      "Smooth and gentle with a natural sweetness and slightly nutty taste.",
  },
];
module.exports = { teas };
